<template>
    <modal-ui
        :id="id"
        size="modal-sm"
        title="Новый API-клиент">
        <form class="loader" @submit.prevent="send">
            <loader-ui :is-show="state.loader" />
            <div class="row mb-4">
                <div class="col-12">
                    <form-group-ui
                        invalid-feedback="Укажите название"
                        label="Название">
                        <input-ui
                            v-model="state.name"
                            :is-invalid="state.visibleErrors && isNameError"
                            placeholder="Studdom / Партнёр" />
                    </form-group-ui>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <button-ui button-class="btn-primary">
                        Создать
                    </button-ui>
                </div>
            </div>
        </form>
    </modal-ui>
</template>

<script lang="ts">
import { computed, defineComponent, reactive } from 'vue';
import { useModal } from '@/composables/useModal';
import api from '@/api';

export default defineComponent({
    name: 'ApiClientAEModal',
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const modal = useModal(props.id);

        const state = reactive({
            name: '',
            visibleErrors: false,
            loader: false,
        });

        const isNameError = computed(() => !String(state.name).trim().length);

        function send() {
            if (isNameError.value) {
                state.visibleErrors = true;
                return;
            }

            state.visibleErrors = false;
            state.loader = true;

            api.v1.apiClients.create({
                name: String(state.name).trim(),
            }).then((r: any) => {
                modal.ok({
                    client: r.data?.data?.client,
                    apiKey: r.data?.data?.apiKey,
                    warning: r.data?.data?.warning,
                });
            }).finally(() => {
                state.loader = false;
            });
        }

        return {
            state,
            isNameError,
            send,
        };
    },
});
</script>
